const data = {
	"width": 24,
	"height": 24,
	"body": "<g id=\"evaBookOpenFill0\"><g id=\"evaBookOpenFill1\"><path id=\"evaBookOpenFill2\" fill=\"currentColor\" d=\"M21 4.34a1.24 1.24 0 0 0-1.08-.23L13 5.89v14.27l7.56-1.94A1.25 1.25 0 0 0 21.5 17V5.32a1.25 1.25 0 0 0-.5-.98ZM11 5.89L4.06 4.11A1.27 1.27 0 0 0 3 4.34a1.25 1.25 0 0 0-.48 1V17a1.25 1.25 0 0 0 .94 1.21L11 20.16Z\"/></g></g>"
};
exports.__esModule = true;
exports.default = data;
